import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  title = 'WorldERP.com About';

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com About'},
      {property: 'og:type', content: 'about'},
      {property: 'og:url', content: '/about'},
      {property: 'og:image', content: ''}
    ]);
  }

}
